<script>
    export let device;
    let colour = device.colour_coding;
    device = device.compound;
    let device_name = device.name;
    let street = device.watermeterconfigs[0].street;
    let house_number = device.watermeterconfigs[0].house_number;
    let display_adress = "";
    if (street) {
        display_adress += street;
        if (house_number) {
            display_adress += " " + house_number;
        }
    } else {
        display_adress = "Keine Adresse";
    }

</script>

<div class="card card-small card-{colour}">
    <div class="card-body card-body-small">
        <h5 class="card-title card-title-small">{device_name}</h5>
        <p class="card-text">
            {display_adress}
        </p>
    </div>
</div>
